import type { ComponentProps, PropsWithChildren } from 'react'

import { Icon } from '@/shared/components/icon'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/shared/components/ui/accordion'
import { Badge } from '@/shared/components/ui/badge'
import { cn } from '@/shared/lib'

const CardsEtapas = ({ className, children, ...props }: ComponentProps<typeof Accordion>) => {
  return (
    <Accordion className={cn('grid w-full gap-6', className)} {...props}>
      {children}
    </Accordion>
  )
}

interface CardEtapaItemProps {
  titulo: string
  descricao: string
  completed?: boolean
}
const CardEtapaItem = ({ completed = false, titulo, descricao, children }: PropsWithChildren<CardEtapaItemProps>) => {
  return (
    <AccordionItem className="shadow-cz rounded-md border" value={titulo}>
      <AccordionTrigger className="px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
          <Badge className="rounded-full p-2.25 [&>svg]:size-6" variant={completed ? 'success' : 'warning'}>
            <Icon name={completed ? 'circle-check' : 'circle-alert'} />
          </Badge>
          <div className="flex flex-col gap-2">
            <p className="text-xl font-normal text-sky-950 uppercase">{titulo}</p>
            <p className="text-sm font-normal text-neutral-700">{descricao}</p>
          </div>
        </div>
      </AccordionTrigger>
      {children}
    </AccordionItem>
  )
}

const CardEtapaContent = ({ className, children, ...props }: ComponentProps<typeof AccordionContent>) => {
  return (
    <AccordionContent className={cn('flex flex-col gap-4 p-6 pt-2', className)} {...props}>
      {children}
    </AccordionContent>
  )
}

export { CardsEtapas, CardEtapaItem, CardEtapaContent }
